/**
 * Devices
 * Devices
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = BestMatch, 1 = AllTerms, 2 = Phrase, 3 = Fuzzy
 */
export enum SearchMode {
    BestMatch = 0,
    AllTerms = 1,
    Phrase = 2,
    Fuzzy = 3
}

